import React from 'react';
import Fire from '../../../assets/images/betshop/fire.png';
import Ice from '../../../assets/images/betshop/ice.png';
import { COLOR_BY_NUMBER } from '../../../enums/colorByNumber';

const HotNumbersBetShop = ({ betShopStatistic, activeLastRound }) => {
  if (!betShopStatistic) {
    return null;
  }
  return (
    <div className='roulette-hot-n-cold-rows'>
      <div className='roulette-hot-n-cold-row'>
        <span className='roulette-hot-n-cold-icon'>
          <img src={Fire} alt='' />
        </span>
        <ul className='roulette-hot-n-cold-list'>
          {betShopStatistic[activeLastRound]?.hotNumbers?.map((item, index) => {
            return (
              <li key={index} className={`roulette-hot-n-cold-li ${COLOR_BY_NUMBER[item].color}`}>
                {item}
              </li>
            );
          })}
        </ul>
      </div>
      <div className='roulette-hot-n-cold-row'>
        <span className='roulette-hot-n-cold-icon'>
          <img src={Ice} alt='' />
        </span>
        <ul className='roulette-hot-n-cold-list'>
          {betShopStatistic[activeLastRound]?.coldNumbers?.map((item, index) => {
            return (
              <li key={index} className={`roulette-hot-n-cold-li ${COLOR_BY_NUMBER[item].color}`}>
                {item}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
export default HotNumbersBetShop;
